import * as z from "zod";

export enum GiftReceiptAuthError {
  GIFT_RECEIPT_NOT_FOUND = "GIFT_RECEIPT_NOT_FOUND",
  GIFT_RECEIPT_DISABLED = "GIFT_RECEIPT_DISABLED",
  GIFT_RECEIPT_ALREADY_USED = "GIFT_RECEIPT_ALREADY_USED",
}

export const giftReceiptAuth = {
  name: "giftReceiptAuth" as const,
  input: z.object({ giftReceiptId: z.string() }),
  output: z.object({
    customerAuthToken: z.string(),
    orderId: z.string(),
    gifterName: z.string(),
    gifterEmail: z.string().optional(),
  }),
};
